{
  "de": {
    "message": {
      "actions": {
        "delete_message": "Nachricht löschen",
        "move_selected": "Ausgewählte Nachrichten verschieben",
        "send": "Senden"
      },
      "labels": {
        "already_replied": "hat bereits eine Antwort",
        "cannot_delete_message": "Diese Nachricht wurde bereits vom Kunden gelesen und kann daher nicht gelöscht werden.",
        "changes_not_saved": "Sie haben nicht gespeicherte Änderungen. Sind Sie sicher, dass Sie fortfahren möchten?\nP.S.: Sie können einen neuen Tab öffnen, um gleichzeitig zu anderen Seiten zu navigieren.",
        "delete_message": "Dies löscht die Nachricht für alle. Bedenken Sie, dass je nach den Einstellungen des Empfängers möglicherweise bereits eine E-Mail-Benachrichtigung gesendet wurde.",
        "delete_message_abort": "Nachricht kann nicht gelöscht werden",
        "move_customer_notification": "Der Kunde wird benachrichtigt, wenn die Nachricht in eine andere Konversation verschoben wird",
        "move_to": "Nachricht verschieben nach …",
        "moved_here": "hierher aus Konversation",
        "moved_message": "hat diese Nachricht verschoben",
        "moving_message": "Nachricht wird verschoben",
        "notSeenYet": "Noch nicht gesehen",
        "seen_by": "Gesehen von {participants}",
        "to": "nach",
        "you": "Sie"
      },
      "validation": {
        "message_required": "Nachricht ist erforderlich"
      }
    }
  }
}
